var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SweetModal',{ref:"modal",staticClass:"error-modal successModal-icon",attrs:{"icon":"warning","hide-close-button":true,"overlay-theme":"dark","blocking":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t('WRONG_URL')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }